import {
  dl_insuranceConstants,
  alertConstants,
  userConstants,
} from "../constants";
import { dl_insuranceService, dealjacketService } from "../services";
import { alertActions } from "./alert.actions.js";

export const dl_insuranceActions = {
  getList,
  assignDealNumber,
  selectSubmissionSet,
  updateDealNumberInputField,
  clearDealNumberRequestFromState,
  createDealJacketFromDealNumber,
  assignIdentityToJacket,
  clearSelectedDealJacketFromState,
  displayAlertMessage,
  setImageRotation,
};

/**
 * Set Image Rotation
 * @param {int} page_id from DL Insurance>Groups>Pages
 * @param {int} rotation [1: 90deg, 2: 180deg, 3: 270deg]
 * @returns action,
 */
function setImageRotation(page_id, rotation) {
  return {
    type: "rotate_dl_insurance_image",
    page_id: page_id,
    rotation: rotation
  }
}

function clearDealNumberRequestFromState() {
  return { type: dl_insuranceConstants.DL_INSURANCE_CLEAR_DEAL_NUMBER_REQUEST };
}

function clearSelectedDealJacketFromState() {
  return { type: dl_insuranceConstants.DL_INSURANCE_CLEAR_DEAL_JACKET_SUCCESS };
}

function selectSubmissionSet(deal_jacket) {
  return { type: dl_insuranceConstants.DL_INSURANCE_SELECT_SUBMISSION, deal_jacket };
};

function updateDealNumberInputField(deal_number_entry) {
  return { type: dl_insuranceConstants.DL_INSURANCE_UPDATE_DEAL_NUMBER_INPUT_FIELD, deal_number_entry };
};

function displayAlertMessage(alert_message, alert_type) {
  return {
    type: dl_insuranceConstants.DL_INSURANCE_DISPLAY_ALERT_MESSAGE,
    alert_message,
    alert_type,
  };
}

function getList(org_id) {
  return (dispatch) => {
    dispatch(fetchAlert("fetching submissions..."));
    dispatch(listRequest(org_id));

    dl_insuranceService.getList(org_id).then(
      (list) => {
        dispatch(refreshToken(list.newToken));
        list.sort((a, b) => b.date_added.localeCompare(a.date_added));
        dispatch(clearAlert());
        dispatch(success(list));
      },
      (error) => {
        dispatch(clearAlert());
        dispatch(failure(error));
        /*dispatch(alertActions.error('unable to reach remote server.'));*/
      }
    );
  };

  function fetchAlert(message) {
    return { type: alertConstants.SPINNER, message };
  }
  function listRequest(org_id) {
    return {
      type: dl_insuranceConstants.DL_INSURANCE_LIST_REQUEST,
      org_id,
    };
  }
  function refreshToken(token) {
    return { type: userConstants.TOKEN_REFRESH, token };
  }
  function clearAlert() {
    return { type: alertConstants.CLEAR };
  }
  function success(list) {
    return { type: dl_insuranceConstants.DL_INSURANCE_LIST_SUCCESS, list };
  }
  function failure(message) {
    return {
      type: dl_insuranceConstants.DL_INSURANCE_LIST_FAILURE,
      message,
    };
  }
}

function assignDealNumber(org_id, deal_jacket_id, deal_number) {
  return (dispatch) => {
    dispatch(
      fetchAlert(
        "Assigning deal number " + deal_number + " to " + deal_jacket_id
      )
    );

    dl_insuranceService
      .assignDealNumber(org_id, deal_jacket_id, deal_number)
      .then(
        (deal_jacket) => {
          dispatch(refreshToken(deal_jacket.newToken));
          dispatch(clearAlert());
          dispatch(success(deal_jacket));
        },
        (error) => {
          dispatch(clearAlert());
          dispatch(failure(error));
          /*dispatch(alertActions.error('unable to reach remote server.')); */
        }
      );
  };

  function fetchAlert(message) {
    return { type: alertConstants.SPINNER, message };
  }
  function refreshToken(token) {
    return { type: userConstants.TOKEN_REFRESH, token };
  }
  function clearAlert() {
    return { type: alertConstants.CLEAR };
  }
  function success(pages) {
    return {
      type: dl_insuranceConstants.DL_INSURANCE_ASSIGN_DEAL_NUMBER_SUCCESS,
      pages,
    };
  }
  function failure(message) {
    return {
      type: dl_insuranceConstants.DL_INSURANCE_ASSIGN_DEAL_NUMBER_FAILURE,
      message,
    };
  }
}

function createDealJacketFromDealNumber(org_id, deal_number) {
  return (dispatch) => {
    dispatch(
      fetchAlert(
        "Creating deal with deal number " + deal_number + "."
      )
    );

    dealjacketService
      .createDealJacketFromDealNumber(org_id, deal_number)
      .then(
        (deal_jacket) => {
          dispatch(refreshToken(deal_jacket.newToken));
          dispatch(clearAlert());
          dispatch(success(deal_jacket));
        },
        (error) => {
          dispatch(clearAlert());
          dispatch(failure(error));
          /*dispatch(alertActions.error('unable to reach remote server.')); */
        }
      );
  };

  function fetchAlert(message) {
    return { type: alertConstants.SPINNER, message };
  }
  function refreshToken(token) {
    return { type: userConstants.TOKEN_REFRESH, token };
  }
  function clearAlert() {
    return { type: alertConstants.CLEAR };
  }
  function success(deal_jacket) {
    return {
      type: dl_insuranceConstants.DL_INSURANCE_CREATE_JACKET_FROM_DEAL_NUMBER_SUCCESS,
      deal_jacket,
    };
  }
  function failure(message) {
    return {
      type: dl_insuranceConstants.DL_INSURANCE_ASSIGN_DEAL_NUMBER_FAILURE,
      message,
    };
  }
}

function assignIdentityToJacket(target_deal_jacket_id, identity_jacket, list) {
  return (dispatch) => {
    dispatch(enterProcessingState());
    dl_insuranceService
      .assignIdentityToJacket(target_deal_jacket_id, identity_jacket)
      .then(
        (receiving_deal_jacket) => {
          dispatch(refreshToken(receiving_deal_jacket.newToken));
          dispatch(clearAlert());
          dispatch(success(receiving_deal_jacket, identity_jacket));
          dispatch(listRequest(list, identity_jacket));
        },
        (error) => {
          dispatch(clearAlert());
          dispatch(failure(error));
          /*dispatch(alertActions.error('unable to reach remote server.')); */
        }
      );
  };

  function fetchAlert(message) {
    return { type: alertConstants.SPINNER, message };
  }
  function refreshToken(token) {
    return { type: userConstants.TOKEN_REFRESH, token };
  }
  function listRequest(list, identity_jacket) {
    return {
      type: "update_dl_insurance_list_after_identity_assignment",
      list: list.filter( item => item.deal_jacket_id !== identity_jacket.deal_jacket_id ),
    };
  }
  function clearAlert() {
    return { type: alertConstants.CLEAR };
  }
  function enterProcessingState() {
    return { type: "dl_insurance_processing_state" };
  }
  function success(receiving_deal_jacket, identity_jacket) {
    return {
      type: dl_insuranceConstants.DL_INSURANCE_ASSIGN_IDENTITY_JACKET_TO_DEAL_JACKET_SUCCESS,
      receiving_deal_jacket,
      identity_jacket,
    };
  }
  function failure(message) {
    return {
      type: dl_insuranceConstants.DL_INSURANCE_ASSIGN_IDENTITY_JACKET_TO_DEAL_JACKET_FAILURE,
      message,
    };
  }
}
